import { useState } from 'react';

import { ConflictAlertSeverityBadge } from '../../components';

import type { ConflictAlertVM, ConflictSeverityVM } from '../../view-models';
import type React from 'react';

export interface SeverityGroupProps {
  label: string;
  sev: ConflictSeverityVM;
  alerts: ConflictAlertVM[];
  sla: string;
  defaultOpen: boolean;
  renderCard: (a: ConflictAlertVM) => React.ReactNode;
}

// Verbatim de design-references/brief-3/centro-alertas.app.jsx:389-416 (function SeverityGroup).
export function SeverityGroup({
  label,
  sev,
  alerts,
  sla,
  defaultOpen,
  renderCard,
}: SeverityGroupProps): React.JSX.Element {
  const [open, setOpen] = useState(defaultOpen);
  const count = alerts.length;
  const empty = count === 0;
  return (
    <section className={'ca-sev-group' + (empty ? ' ca-sev-group--empty' : '')}>
      <header className="ca-sev-group__head">
        <ConflictAlertSeverityBadge severity={sev} />
        <h2>{label}</h2>
        <span className="ca-sev-group__count">({count})</span>
        <span className="tweaks-hint">SLA mitigação: {sla}</span>
        {!empty && (
          <button className="ca-sev-group__toggle" onClick={() => setOpen((v) => !v)}>
            {open ? 'colapsar ▴' : 'expandir ▾'}
          </button>
        )}
      </header>
      {empty ? (
        <div className="ca-sev-group__empty">Nenhum alerta {label.toLowerCase()} ativo.</div>
      ) : open ? (
        alerts.map(renderCard)
      ) : (
        <div className="tweaks-hint" style={{ paddingLeft: 4 }}>
          {count} alertas colapsados. Clique em "expandir".
        </div>
      )}
    </section>
  );
}
